import React from "react";
import styled from "styled-components";
import { Theme } from "../../themes/theme";
import { inputStyles } from "./InputStyles";

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 6px;

  label {
    text-transform: uppercase;
    font-size: ${Theme.font.fontSize.xs};
    font-weight: ${Theme.font.fontWeight.medium};
    letter-spacing: ${Theme.font.letterSpacing.widest};
    color: ${Theme.color.text.secondary};
  }
`;

const TextArea = styled.textarea`
  ${inputStyles}

  appearance: none;

  @media (max-width: ${Theme.breakpoints.MOBILE}px) {
    font-size: ${Theme.font.fontSize.md};
  }
`;

function PrimaryTextArea({ label, error, ...props }) {
  return (
    <Wrapper>
      <label>{label}</label>

      <TextArea {...props} />

      {error && <span>{error}</span>}
    </Wrapper>
  );
}

export default PrimaryTextArea;
